import { Box } from "@chakra-ui/react";
import Card2Horizontal from "components/Cards/Card2Horizontal";
import colors from "core/resources/theme/colors";
import PanelPrevisaoOrcamentaria from "../PanelExecucaoOrcamentaria";
import { Image } from "@chakra-ui/react";
import cashRed from "assets/images/svgs/cash-multiple-red.svg";
import cashGreen from "assets/images/svgs/cash-stack-green.svg";
import { ExecucaoOrcamentariaDetalheResponse } from "core/features/execucao-orcamentaria/typings";
import { TipoArrecadacaoEnum } from "features/arrecadacoes/enums";
import { formatMoney } from "infra/helpers/number";
import { Row } from "antd";
import { Col } from "antd";

interface DashboardPrevisaoOrcamentariaProps {
  isFetching?: boolean;
  isLoading?: boolean;
  data: ExecucaoOrcamentariaDetalheResponse | undefined;
}

export default function DashboardPrevisaoOrcamentaria({
  isFetching,
  data,
  isLoading,
}: DashboardPrevisaoOrcamentariaProps) {
  const getTextValorArrecadacao = () => {
    const textMapping: Partial<Record<TipoArrecadacaoEnum, string>> = {
      [TipoArrecadacaoEnum.ValorIgualTodasUnidades]: `${formatMoney(
        data?.valorArrecadacao ?? 0
      )} por unidade`,
      [TipoArrecadacaoEnum.ValorMetrosUnidade]: `${formatMoney(
        data?.valorArrecadacao ?? 0
      )} por m²`,
    };

    if (data?.tipoArrecadacaoId) {
      return textMapping[data.tipoArrecadacaoId];
    }
  };

  const textValorArrecadacao = getTextValorArrecadacao();

  const receita = data?.receitas[0];

  const despesa = data?.despesas[0];

  const getColorResultado = () => {
    if (data?.resultado) {
      return data.resultado > 0 ? colors.accentBlue : colors.red;
    }
    return undefined;
  };

  const getIconBgResultado = () => {
    if (data?.resultado) {
      return data.resultado > 0 ? colors.blue100 : colors.red100;
    }
    return colors.black100;
  };

  const getIconColorFilter = () => {
    if (data?.resultado) {
      return data.resultado > 0
        ? "brightness(0) saturate(100%) invert(77%) sepia(9%) saturate(5257%) hue-rotate(180deg) brightness(100%) contrast(90%);" // #7BB8F2;
        : undefined;
    }
    return "brightness(0) saturate(100%) invert(61%) sepia(14%) saturate(34%) hue-rotate(169deg) brightness(83%) contrast(84%);"; // #E53E3E;
  };

  return (
    <Box as={Row} gutter={[20, 20]} mb="40px">
      <Box as={Col} h="fit-content" xs={12} lg={6}>
        {isFetching || !!textValorArrecadacao ? (
          <Card2Horizontal
            icon={<Image src={cashGreen} h="20px" />}
            color={colors.green100}
            bg={colors.green100}
            description={"Cota condominial prevista"}
            title={textValorArrecadacao ?? ""}
            loading={isFetching}
            fontSize={18}
          />
        ) : null}
      </Box>
      <Box as={Col} h="fit-content" xs={12} lg={6}>
        <Card2Horizontal
          icon={<Image src={cashRed} h="20px" filter={getIconColorFilter()} />}
          color={getColorResultado()}
          bg={getIconBgResultado()}
          colorTitle={getColorResultado()}
          description={"Resultado"}
          subDescription="(receitas - despesas realizadas)"
          title={`${formatMoney(data?.resultado)} `}
          loading={isFetching}
          fontSize={18}
        />
      </Box>
      <Col xs={24} lg={12}>
        <PanelPrevisaoOrcamentaria
          receita={{
            previsto: receita?.previstoItems ?? 0,
            realizado: receita?.realizadoItems ?? 0,
            saldo: receita?.saldoItems ?? 0,
          }}
          despesa={{
            previsto: despesa?.previstoItems ?? 0,
            realizado: despesa?.realizadoItems ?? 0,
            saldo: despesa?.saldoItems ?? 0,
          }}
          loading={isLoading}
        />
      </Col>
    </Box>
  );
}
